import Swiper from "swiper";
import { A11y, Navigation, Scrollbar } from "swiper/modules";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "@/styles/components/slider.css";
import "./enterprises.css";

const setupSlider = (el) => {
  const container = el.querySelector(".swiper");

  const swiper = new Swiper(container, {
    modules: [A11y, Navigation, Scrollbar],
    speed: 500,
    navigation: {
      nextEl: el.querySelector(".slider-button-next"),
      prevEl: el.querySelector(".slider-button-prev"),
    },
    scrollbar: {
      el: el.querySelector(".swiper-scrollbar"),
      draggable: true,
    },
    simulateTouch: false,
    slidesPerView: 1,
    spaceBetween: 24,
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 36,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 36,
      },
      1280: {
        slidesPerView: 3.5,
        spaceBetween: 36,
      },
      1536: {
        slidesPerView: 3.5,
        spaceBetween: 48,
      },
    },
    on: {
      init: (swiper) => {
        if (swiper.isLocked) {
          el.classList.add("is-locked");
        } else {
          el.classList.remove("is-locked");
        }
      },
      resize: (swiper) => {
        if (swiper.isLocked) {
          el.classList.add("is-locked");
        } else {
          el.classList.remove("is-locked");
        }
      },
    },
  });

  return swiper;
};

document.querySelectorAll(".element-enterprises.as-default").forEach((el) => {
  let swiper = setupSlider(el);

  el.addEventListener("enterprises:toggle", (e) => {
    const isViewAll = e.detail.all;

    if (isViewAll) {
      el.classList.add("is-view-all");
      swiper.destroy(true, true);
    } else {
      el.classList.remove("is-view-all");
      swiper = setupSlider(el);
    }

    ScrollTrigger.refresh();
  });
});
